// src/ImageDrop.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ImageDrop_default = createIcon({
  displayName: "ImageDrop",
  viewBox: "0 0 96 96",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "96",
        height: "96",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M47 83C66.8823 83 83 66.8823 83 47C83 27.1177 66.8823 11 47 11C27.1177 11 11 27.1177 11 47C11 66.8823 27.1177 83 47 83ZM37.6851 46.8102L45.8867 54.5102C46.1845 54.7865 46.5757 54.94 46.9819 54.94C47.3881 54.94 47.7793 54.7865 48.0771 54.5102L56.2387 46.8102C56.3463 46.695 56.4221 46.5537 56.4587 46.4002C56.4877 46.2453 56.4703 46.0853 56.4087 45.9402C56.353 45.7924 56.2513 45.6662 56.1187 45.5802C55.9856 45.4906 55.8291 45.4419 55.6686 45.4402H50.1775V32.6202C50.1773 32.4078 50.1366 32.1974 50.0575 32.0002C49.9851 31.8033 49.8688 31.6255 49.7174 31.4802C49.5709 31.3258 49.3939 31.2034 49.1976 31.1208C49.0014 31.0381 48.7901 30.9971 48.5772 31.0002H45.3866C44.9622 31.0002 44.5551 31.1688 44.255 31.4689C43.9549 31.7689 43.7863 32.1759 43.7863 32.6002V45.4002H38.1952C38.0922 45.4 37.9901 45.4204 37.8951 45.4602C37.796 45.4951 37.7068 45.5534 37.6351 45.6302C37.5555 45.7016 37.4938 45.7906 37.4551 45.8902C37.4152 45.9852 37.3948 46.0872 37.395 46.1902C37.3952 46.2964 37.4165 46.4015 37.4577 46.4994C37.499 46.5972 37.5592 46.6859 37.6351 46.7602L37.6851 46.8102ZM62.88 60.8102C62.8041 60.6122 62.6883 60.4318 62.5399 60.2802C62.396 60.1294 62.2223 60.0102 62.0298 59.9302C61.837 59.8471 61.6296 59.8029 61.4197 59.8002H32.6141C32.2987 59.7995 31.99 59.8914 31.7263 60.0645C31.4627 60.2376 31.2557 60.4844 31.131 60.7741C31.0064 61.0638 30.9696 61.3837 31.0252 61.6941C31.0808 62.0045 31.2264 62.2918 31.4439 62.5202C31.7406 62.8199 32.1425 62.9921 32.5641 63.0002H61.3697C61.5811 62.9987 61.7907 62.9615 61.9898 62.8902C62.1816 62.8079 62.3575 62.6929 62.5099 62.5502C62.6608 62.4005 62.7829 62.2242 62.87 62.0302C62.9485 61.836 62.9925 61.6296 63 61.4202C63.0008 61.211 62.96 61.0036 62.88 60.8102Z",
        fill: "currentColor"
      })
    ]
  })
});

export {
  ImageDrop_default
};
